import { Component, EventEmitter, Injector, Output, ViewChild } from '@angular/core';
import { CommonLookupModalComponent } from '@app/shared/common/lookup/common-lookup-modal.component';
import { AppComponentBase } from '@shared/common/app-component-base';
import {
    CommonLookupServiceProxy,
    CreateUserDelegationDto,
    FindUsersInput,
    FindUsersOutputDto,
    UserDelegationServiceProxy
} from '@shared/service-proxies/service-proxies';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { finalize } from 'rxjs/operators';
import { AppBsModalDirective } from '../../../shared/common/appBsModal/app-bs-modal.directive';
import { DateTimeService } from '../common/timing/date-time.service';

import { FormsModule } from '@angular/forms';
import { LocalizePipe } from '@shared/common/pipes/localize.pipe';
import { BsDatepickerDirective, BsDatepickerInputDirective } from 'ngx-bootstrap/datepicker';
import { ButtonBusyDirective } from '../../../shared/utils/button-busy.directive';
import { DatePickerLuxonModifierDirective } from '../../../shared/utils/date-time/date-picker-luxon-modifier.directive';
import { CommonLookupModalComponent as CommonLookupModalComponent_1 } from '../common/lookup/common-lookup-modal.component';

@Component({
    selector: 'createNewUserDelegation',
    templateUrl: './create-new-user-delegation-modal.component.html',
    imports: [
    AppBsModalDirective,
    FormsModule,
    BsDatepickerInputDirective,
    BsDatepickerDirective,
    DatePickerLuxonModifierDirective,
    ButtonBusyDirective,
    CommonLookupModalComponent_1,
    LocalizePipe
],
})
export class CreateNewUserDelegationModalComponent extends AppComponentBase {
    @ViewChild('userDelegationModal', { static: true }) modal: ModalDirective;
    @ViewChild('userLookupModal', { static: true }) userLookupModal: CommonLookupModalComponent;
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;
    selectedUsername = '';

    userDelegation: CreateUserDelegationDto = new CreateUserDelegationDto();

    constructor(
        injector: Injector,
        private readonly _userDelegationService: UserDelegationServiceProxy,
        private readonly _commonLookupService: CommonLookupServiceProxy,
        private readonly _dateTimeService: DateTimeService,
    ) {
        super(injector);
    }

    show(): void {
        this.active = true;
        this.userDelegation = new CreateUserDelegationDto();

        this.userLookupModal.configure({
            title: this.l('SelectAUser'),
            dataSource: (skipCount: number, maxResultCount: number, filter: string, tenantId?: number) => {
                let input = new FindUsersInput();
                input.filter = filter;
                input.excludeCurrentUser = true;
                input.maxResultCount = maxResultCount;
                input.skipCount = skipCount;
                input.tenantId = tenantId;
                return this._commonLookupService.findUsers(input);
            },
        });

        this.modal.show();
    }

    showCommonLookupModal(): void {
        this.userLookupModal.show();
    }

    userSelected(user: FindUsersOutputDto): void {
        this.userDelegation.targetUserId = user.id;
        this.selectedUsername = user.name;
    }

    setUserIdNull() {
        this.userDelegation.targetUserId = null;
        this.selectedUsername = null;
    }

    save(): void {
        this.saving = true;

        let input = new CreateUserDelegationDto();
        input.targetUserId = this.userDelegation.targetUserId;
        input.startTime = this._dateTimeService.getStartOfDayForDate(this.userDelegation.startTime);
        input.endTime = this._dateTimeService.getEndOfDayForDate(this.userDelegation.endTime);

        this._userDelegationService
            .delegateNewUser(input)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe(() => {
                this.notify.info(this.l('SavedSuccessfully'));
                this.close();
                this.modalSave.emit(null);
            });
    }

    close(): void {
        this.active = false;
        this.selectedUsername = '';
        this.modal.hide();
    }
}
